/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class FormModel {

        public processType: Wars.Domain.Model.ProcessType = null;
        public formConfiguration: Wars.Domain.Model.Form= null;
        public currentStep: Wars.Domain.Model.FormStep = null;
        public process = {};
        public fields: Wars.Domain.Model.Field[];
        public manageProcess = undefined;

        private previousSaveJson: string;
        public currentStepIndex: number;
        public processErrors;
        public isReadOnly: boolean = false;
        private customStepFunctions: any;

        private scope: ng.IScope;

        constructor(
            private processTypeId: string,
            private processTypeService: services.ProcessTypeService,
            private processConfigurationService: services.ProcessConfigurationService,
            private httpService: angular.IHttpService,
            private locationService: angular.ILocationService,
            public processId: string,
            private processValidationService: services.ProcessValidationService,
            private growl: angular.growl.IGrowlService,
            private modalService: any,
            private angularLoader: services.AngularLoadService,
            scope: ng.IScope,
            private formSectionService: services.FormSectionService) {
            var self = this;
            this.scope = scope;

            this.customStepFunctions = [];
            this.process = {};
            this.loadCustomStepJavascript();
        }

        private loadCustomStepJavascript() {
                this.formConfiguration.urlDependencies.forEach(url => {
                    if (url.type == Wars.Domain.Model.Codes.Enums.UrlDependencyType.Javascript) {
                        this.angularLoader.loadScript(url.url);
                    } else {
                        this.angularLoader.loadCSS(url.url);
                    }
                });

            /*    if (!this.customStepFunctions[this.currentStep.id]) {
                    //var functionStr = "(" + this.currentStep.javascript + ")";
                    //this.customStepFunctions[this.currentStep.id] = eval(functionStr)();
                }
                //TODO: This is a hack fix after the demo
                setTimeout(() => this.customStepFunctions[this.currentStep.id].stepLoaded(this.process, () => { }, this.isReadOnly), 1599);*/
        }

        public selectStep(position: number) {
            var index = 0;
            if (position > 0) {
                index = Enumerable.from(this.formConfiguration.mySteps).indexOf(s => s.position == position);
            }
            this.currentStep = this.formConfiguration.mySteps[index];

            this.currentStepIndex = position

            if (this.customStepFunctions && this.customStepFunctions.length>0) {
                this.process = this.customStepFunctions[this.currentStep.id].stepUnload(this.isReadOnly);
                this.save();
            }

            var step = Enumerable.from(this.formConfiguration.mySteps).single(s => s.position === position);
            this.currentStep = step;

            this.currentStep.formSections.forEach(g => {
                this.formSectionService.splitFields(g);
            });


            this.loadFieldsConditions();

            //this.runStepConditions();
            this.runStepFieldCondtions();
            this.runFormSectionConditions();
        }

        public loadFieldsConditions() {
            this.fields = [];
            if (this.currentStep.formSections) {
                for (var i = 0; i < this.currentStep.formSections.length; i++) {
                    var formSection = this.currentStep.formSections[i];

                    if (formSection.objectSchema.isList && !this.processId) {
                        this.process[formSection.objectSchema.name] = [];
                    }

                    if (formSection.fields) {
                        for (var x = 0; x < formSection.fields.length; x++) {
                            if (formSection.fields[x].condition_id == null)
                                continue;

                            this.fields.push(formSection.fields[x]);
                        }
                    }
                }
            }
        }

        private runFormSectionConditions() {
            this.currentStep.formSections.forEach(g => {
                //this.executeGroupCondition(g);
            });
        }

        private runStepFieldCondtions() {
            for (let i = 0; i < this.fields.length; i++) {
                //this.executeCondition(this.fields[i]);
            }
        }

        public processChanged() {
            //this.runStepConditions();
            this.runStepFieldCondtions();
            this.runFormSectionConditions();
        }


        public fieldBlurred() {
            //TODO:Fix this
            //_formModelSelf.save();
            //_formModelSelf.processChanged();
        }

        public goto(errorObj: any) {
            var step = Enumerable.from(this.formConfiguration.mySteps).single(x => x.id == errorObj.stepId);
            this.selectStep(step.position);
            //this.currentStep = step;
            //this.currentStepIndex = step.position;
            if (errorObj.rowId) {
                setTimeout(() => {
                    $('#' + errorObj.rowId).click();
                    setTimeout(() => { $('#' + errorObj.fieldId).focus(); }, 100);
                }, 100);

            } else {
                setTimeout(() => { $('#' + errorObj.fieldId).focus(); }, 100);
            }

        }

        public save(callback?:any) {
            var currentJson = JSON.stringify(this.process);
            if (currentJson == this.previousSaveJson) {
                return;
            } else {
                this.previousSaveJson = currentJson;
            }
            var body = this.process;
            this.httpService.post('./api/Process/' + this.processId, body).then(result => { 
                if(callback){
                    callback();
            }
        });
        }
    }
}